// extracted by mini-css-extract-plugin
module.exports = {"svgPi":"ProgressBar_svg-pi___8fWf","svgPi__wrapper":"ProgressBar_svg-pi__wrapper__3RNSH","svgPi__label":"ProgressBar_svg-pi__label__iW5OA"};